<ds-badge size="medium" variant="primary" class="acca-boost-logo">
    {{ accaBoostRewardTitle() }}
    <vn-icon name="theme-acca-boost" slot="start" class="acca-boost-logo-icon" [size]="accaBoostInfoIconSize" />
</ds-badge>
@if (showInfoIcon()) {
    <vn-icon name="theme-info" class="icon-theme-info" [size]="accaBoostInfoIconSize" (click)="onClickInfo()" />
}
